import React from 'react';
import { observer } from 'mobx-react';
import { AppUI } from '@seedlang/state';
import styled from '@emotion/styled';
import { computed } from 'mobx';
import SettingsMenuRow from './settings_menu_row';
import SeedlangOnly from 'utils/seedlang_only';
import MemrevOnly from 'utils/memrev_only';

export const MenuContainer = styled.div`
  grid-area: menu;
  width: ${props => props.width};
  margin: ${props => props.margin};
  border-radius: ${props => props.borderRadius};
  overflow: hidden;
  border: ${props => props.isMobile ? '1px solid #e0e0e0' : 0};
  box-sizing: border-box;
`;

@observer
class SettingsMenu extends React.Component {
  @computed get navigationItems() {
    return AppUI.site.navigationItems
      .filter(item => item.showInUserSettings && item.path.startsWith('/pages/'))
      .map(item => {
        const match = item.path.match(/\/pages\/(.*)/);
        return { name: item.name, id: item.id, pageId: match ? match[1] : null };
      });
  }

  routeIsSelected(routeName, params = {}) {
    return AppUI.routeStore.routeName === routeName
      && Object.keys(params).every(key => AppUI.routeStore.params?.[key] === params[key]);
  }

  render() {
    return (
      <MenuContainer
        width={AppUI.layout.isMobile ? (this.props.embeddedMobile ? '100%' : 'calc(100% - 30px)') : '250px'}
        margin={AppUI.layout.isMobile ? (this.props.embeddedMobile ? '0 0 20px' : '20px 15px') : null}
        borderRadius={AppUI.layout.isMobile ? '14px' : '10px'}
        isMobile={AppUI.layout.isMobile}
      >
        <SettingsMenuRow
          to='settings.user_profile'
          selected={this.routeIsSelected('settings.user_profile')}
        >
          User Settings
        </SettingsMenuRow>
        <SeedlangOnly>
          <SettingsMenuRow
            to='settings.user_image'
            selected={this.routeIsSelected('settings.user_image')}
          >
            Profile Image
          </SettingsMenuRow>
          <SettingsMenuRow
            to='settings.password'
            selected={this.routeIsSelected('settings.password')}
          >
            Change Password
          </SettingsMenuRow>
          <SettingsMenuRow
            to='settings.deck'
            selected={this.routeIsSelected('settings.deck')}
          >
            Deck Settings
          </SettingsMenuRow>
          <SettingsMenuRow
            to='settings.clear_progress'
            selected={this.routeIsSelected('settings.clear_progress')}
          >
            Clear Progress
          </SettingsMenuRow>
          <SettingsMenuRow
            to='settings.streak_repair'
            selected={this.routeIsSelected('settings.streak_repair')}
          >
            Streak Repair
          </SettingsMenuRow>
          <SettingsMenuRow
            to='settings.user_notifications'
            selected={this.routeIsSelected('settings.user_notifications')}
          >
            Notifications
          </SettingsMenuRow>
        </SeedlangOnly>
        <SettingsMenuRow
          to='settings.billing'
          selected={this.routeIsSelected('settings.billing')}
        >
          {AppUI.siteIsSeedlang ? 'Manage Subscription' : 'Manage Membership'}
        </SettingsMenuRow>
        <MemrevOnly>
          <SettingsMenuRow
            to='settings.email'
            selected={this.routeIsSelected('settings.email')}
          >
            Email Preferences
          </SettingsMenuRow>
        </MemrevOnly>
        <MemrevOnly>
          <SettingsMenuRow
            to='settings.audio_feeds'
            selected={this.routeIsSelected('settings.audio_feeds')}
          >
            Audio Feeds
          </SettingsMenuRow>
        </MemrevOnly>
        {
          this.navigationItems.map(navigationItem => {
            return (
              <SettingsMenuRow
                key={navigationItem.id}
                to={{ name: 'settings.page.show', params: {pageId: navigationItem?.pageId} }}
                selected={this.routeIsSelected('settings.page.show', { pageId: navigationItem?.pageId })}
              >
                {navigationItem.name}
              </SettingsMenuRow>
              );
          })
        }
        <SettingsMenuRow
          to='settings.privacy'
          selected={this.routeIsSelected('settings.privacy')}
        >
          Privacy
        </SettingsMenuRow>
      </MenuContainer>
    );
  }
}

export default SettingsMenu;